<template>
  <div style="padding: 0 6% 0 2%">
    <h2>注册</h2>
    <div style="min-height: 224px">
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="ruleForm.phone"
            size="large"
            placeholder="手机号"
          />
        </el-form-item>
        <el-form-item label="手机验证码" prop="phoneCode">
          <el-row style="width: 100%">
            <el-col :span="14">
              <el-input
                v-model="ruleForm.phoneCode"
                size="large"
                placeholder="验证码"
              />
            </el-col>
            <el-col :span="9" :offset="1">
              <el-button type="info" style="width: 100%" size="large" @click="sendPhoneCode"
                >获取验证码</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="昵称" prop="nickName">
          <el-input
            v-model="ruleForm.nickName"
            size="large"
            placeholder="请输入昵称"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="ruleForm.password"
            size="large"
            type="password"
            show-password
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="rePassword">
          <el-input
            v-model="ruleForm.rePassword"
            size="large"
            type="rePassword"
            show-password
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item>
          <div class="displayFlex justifyContentCenter">
            <el-checkbox v-model="checked" size="large">
              <template #default>
                <p><span style="cursor: default;color: #000;">我已接受并阅读</span><span class="cursorPointer" style="color:#409EFF">《中新金桥免责声明》</span></p>
              </template>
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
            type="primary"
            style="width: 70%;margin-left: 20%;"
            background-color="#E65833"
            @click="submitForm(ruleFormRef)"
            :disabled="!checked"
          >
            提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {getCurrentInstance, reactive, ref} from "vue";
import { smsCode, SubmitRegister} from "@/request/api/register";
import {ElMessage} from "element-plus";
import useLogin from "@/stores/login";
import {useRouter} from "vue-router";
const { proxy } = getCurrentInstance();

const formSize = ref("default");
const ruleFormRef = ref();
const loginStore = useLogin();
const checked = ref(false);

const router = useRouter();
const ruleForm = reactive({
  //手机号
  phone: "",
  //手机验证码
  password: "",
  //昵称
  nickName:"",
  //密码
  phoneCode: "",
  // 确认密码
  rePassword:""
});
const rules = reactive({
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    // { min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
  ],
  nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
  password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  rePassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
  phoneCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
});
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      const loading = proxy.$loading();
      let query = router.currentRoute.value.query  //获取路由上的code
      let code = query.code;
      loginStore.code = null;
      if(code !=undefined && code != null && code != ''){
        loginStore.code = code;
      }
      SubmitRegister(ruleForm).then(res=>{
        loading.close();
        if(res.status == 10000){
          ElMessage.success("注册成功");
          loginStore.showVisible =false;
        }else {
          ElMessage.error(res.msg);
        }
      })
    } else {
      console.log("error submit!", fields);
    }

  });
};


//发送验证码
const sendPhoneCode = () => {
  let data = {
      type:"0",
      phone:ruleForm.phone
  }
  smsCode(data).then(res=>{
    if(res.status == 10000){
      ElMessage.success("发送成功");
    }else {
      ElMessage.error(res.msg);
    }

  })
}




</script>

<style lang="scss" scoped>
@import "@/styles/elementButton.scss";
@import "@/styles/common.scss";
@import "@/styles/variables.scss";
h2 {
  margin: 0 0 30px 0;
  text-align: center;
  color: #000;
}
</style>
